import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Field, PageHeader, Panel } from "../components/common";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Button } from "../components/ui/button";

export default function NewReport() {
  const { reportTypes } = useAuth();
  const nav = useNavigate();
  const [tipo, setTipo] = useState(reportTypes[0] || "");
  const [titolo, setTitolo] = useState("");
  const [contenuto, setContenuto] = useState("");
  const submit = async () => {
    if (!tipo || !titolo.trim() || !contenuto.trim()) return toast.error("Compila tutti i campi");
    try { await api("/reports", { method: "POST", body: { tipo, titolo, contenuto } }); toast.success("Report inviato"); nav("/report"); }
    catch (e) { toast.error(e.message); }
  };
  return (
    <div className="max-w-2xl">
      <PageHeader subtitle="Report" title="Nuovo Report" />
      <Panel className="space-y-5">
        <Field label="Tipo di report"><div className="flex flex-wrap gap-2">{reportTypes.map((t) => (
          <button key={t} onClick={() => setTipo(t)} className={`px-4 py-2 rounded-full text-sm border ${tipo === t ? "bg-[var(--navy)] text-white" : "bg-white"}`} data-testid={`report-type-${t}`}>{t}</button>))}</div></Field>
        <Field label="Titolo"><Input value={titolo} onChange={(e) => setTitolo(e.target.value)} placeholder="Oggetto del report" data-testid="report-title-input" /></Field>
        <Field label="Contenuto"><Textarea rows={8} value={contenuto} onChange={(e) => setContenuto(e.target.value)} data-testid="report-content-input" /></Field>
        <Button onClick={submit} className="rounded-full bg-[var(--teal)] px-8" data-testid="report-submit-button">Invia Report</Button>
      </Panel>
    </div>
  );
}
